import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';

import appService from '@/services/appService';
import {selectLanguageCode} from '@/state/selectors/global';
import {selectIsJourneyBadgePending, selectIsJourneyLevelTaskPending} from '@/state/selectors/loyalty';

import useOnReturnToTab from '../useOnReturnToTab';

const useLoyaltyFetchManager = () => {
    const languageCode = useSelector(selectLanguageCode);
    const isJourneyBadgePending = useSelector(selectIsJourneyBadgePending);
    const isJourneyLevelTaskPending = useSelector(selectIsJourneyLevelTaskPending);
    const isFetchingRef = useRef(false);
    const previousLanguageCodeRef = useRef(languageCode);

    const checkAndFetch = async () => {
        const shouldFetch = isJourneyBadgePending || isJourneyLevelTaskPending;

        if (!shouldFetch || isFetchingRef.current) return;

        isFetchingRef.current = true;

        await appService.fetchLoyaltyJourneys();

        isFetchingRef.current = false;
    };

    useOnReturnToTab(checkAndFetch);

    useEffect(() => {
        const previousLanguageCode = previousLanguageCodeRef.current;

        previousLanguageCodeRef.current = languageCode;

        if (!previousLanguageCode || !languageCode || previousLanguageCode === languageCode) return;

        appService.fetchLoyaltyJourneys();
    }, [languageCode]);
};

export default useLoyaltyFetchManager;
